import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTES } from "@/lib/index";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";

export default function App() {
  return (
    <HashRouter>
      <div className="dark min-h-screen bg-background text-foreground">
        <Header />
        <main>
          <Routes>
            <Route path={ROUTES.HOME} element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}
